import styled from 'styled-components';
import { WithDirection } from '@jjj/components';
import { palette } from 'styled-theme';

const Wrapper = styled.div`
  .ant-tabs-nav {
    border: none;
  }

  .show {
    width: 50% !important;
  }

  .custom-search {
    width: 85% !important;
    padding-left: 719px !important;
  }

  .company-avatar {
    height: 20px;
    width: 20px;
    margin: 0 10px;
    border-radius: 50%;
  }

  .hours-booked-style {
    display: inline-flex;
  }

  .segment-tooltip-value {
    width: 100%;
    text-align: center;
  }

  .hours-booked-warning-icon {
    padding-top: 18px;
    font-size: 12px;
    color: ${palette('warning', 0)};
  }

  .ant-tabs-nav {
    border: none;
    padding-left: 0;
  }

  .ant-tabs-tabpane {
    margin-bottom: 30px;
  }

  .avatar-wrapper {
    display: flex;
    align-items: center;
    position: relative;
    margin-right: 5px;
    margin-left: 5px;

    .ant-avatar {
      margin-right: 5px;
    }
  }
`;

export const TabContentWrapper = styled.div`
  padding-top: 30px;
`;

const SelectAllWrapperStyles = styled.div`
  display: flex;

  .selectAllActionsIcon {
    display: flex;
    align-items: center;
    font-size: 10px;
    padding-left: ${props => (props['data-rtl'] === 'rtl' ? 0 : 4)}px;
    padding-right: ${props => (props['data-rtl'] === 'rtl' ? 4 : 0)}px;
  }
`;

const BulkAccreditationsWrapperStyles = styled.div`
  .text-cell-text-wrapper {
    padding-top: 3px;
  }
`;

const TalentLinkWrapperStyles = styled.div`
  button {
    font-weight: normal !important;
  }
`;

const SelectAllWrapper = WithDirection(SelectAllWrapperStyles);
const BulkAccreditationsWrapper = WithDirection(BulkAccreditationsWrapperStyles);
const TalentLinkWrapper = WithDirection(TalentLinkWrapperStyles);

export { SelectAllWrapper, BulkAccreditationsWrapper, TalentLinkWrapper };

export default WithDirection(Wrapper);
